const translations = {
  "en": {
    "Assets": "Assets",
    "Proportion": "Proportion",
    "Value": "Value"
  },
  "zh-tw": {
    "Assets": "資產",
    "Proportion": "佔比",
    "Value": "價值"
  }
};

export default translations;
